import {useState} from "../../../__snowpack__/pkg/react.js";
import {axios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
export const useEditAlertEmails = () => {
  const [loading, setLoading] = useState(false);
  const postData = async (emails) => {
    setLoading(true);
    try {
      const res = await axios.post("/saas/member/v1/alert-receivers/edit", emails);
      return res;
    } catch (error) {
      handleError(error);
      return error;
    } finally {
      setLoading(false);
    }
  };
  return {
    loading,
    postData
  };
};
